import {Skeleton} from "@mui/material";
import RaikoGridOneColumn from "../../raikoComponents/raikoCustomGrids/RaikoGridOneColumn";
import RaikoGridTwoColumn from "../../raikoComponents/raikoCustomGrids/RaikoGridTwoColumn";
import {css} from "@emotion/css";
import {RaikoAlert, raikoAlertTypes} from "../../raikoComponents/raikoAlert/RaikoAlert";
import {RaikoTree} from "../../raikoComponents/RaikoCategory/RaikoTree";
import {useState} from "react";
import "./Category.scss"
import {RaikoCustomActionChip} from "../../raikoComponents/raikoCustomChip/raikoCustomActionChip/RaikoCustomActionChip";
import RaikoLabel from "../../raikoComponents/raikoCustomLabel/RaikoLabel";

const Category = ({
                      selectedCategoryItems,
                      setSelectedCategoryItems,
                      items,
                      loadingState = false
                  }) => {
    const [selectedTreeItemsId, setSelectedTreeItemsId] = useState([]);

    function handleSelectCategoryItems(id, name, slug) {
        if (!selectedCategoryItems.find(element => element.id === id)) {
            setSelectedTreeItemsId(prevState => [...prevState, id])
            setSelectedCategoryItems(prevState => [
                ...prevState, {
                    id, name, slug
                }
            ])
        }
    }

    function handleDeleteCategory(id) {
        const _selectedCategoryItems = []
        _selectedCategoryItems.push(...selectedCategoryItems)

        selectedCategoryItems.find((element, index) => {
            if (element.id === id) {
                _selectedCategoryItems.splice(index, 1)
            }
        })

        setSelectedCategoryItems(_selectedCategoryItems)

        const _selectedTreeItemsId = []
        _selectedTreeItemsId.push(...selectedTreeItemsId)

        selectedTreeItemsId.find((element, index) => {
            if (element === id) {
                _selectedTreeItemsId.splice(index, 1)
            }
        })

        setSelectedTreeItemsId(_selectedTreeItemsId)
    }

    return (
        <>
            {loadingState ?
                <RaikoGridOneColumn>
                    <Skeleton variant="rectangular" className={css`padding: 32px`}/>
                    <RaikoGridTwoColumn>
                        <Skeleton variant="rectangular" className={css`padding: 64px`}/>
                        <Skeleton variant="rectangular" className={css`padding: 64px`}/>
                    </RaikoGridTwoColumn>
                </RaikoGridOneColumn>
                : items && items.length > 0 ?
                    <RaikoGridOneColumn>
                        <RaikoAlert
                            type={raikoAlertTypes.info}
                            title={"دسته بندی ها"}
                            description={[
                                "* با کلیک بر روی لیست دسته بندی ها می توانید دسته بندی جدید را اضافه نمایید.",
                                "* برای حذف دسته بندی انتخاب شده می توانید بر روی آن کلیک نمایید."
                            ]}
                            className={css`height: fit-content;
                              width: 100%;`}
                        />
                        <RaikoGridTwoColumn>
                            <RaikoGridOneColumn>
                                <RaikoTree
                                    selectedItemsId={selectedTreeItemsId}
                                />
                            </RaikoGridOneColumn>
                            <div className={`selectedItemsDashedContainer`}>
                                {selectedCategoryItems.length > 0 ?

                                    <div className={"chipContainer"}>

                                        {selectedCategoryItems.map((item, index) => {
                                            return <RaikoCustomActionChip
                                                id={item.id}
                                                title={`${item.name} (${item.slug})`}
                                                onClick={handleDeleteCategory}
                                            />
                                        })}
                                    </div>
                                    :
                                    <RaikoLabel className={`warningText`} text={"هنوز هیچ دسته بندی انتخاب نشده است!"}/>
                                }
                            </div>
                        </RaikoGridTwoColumn>
                    </RaikoGridOneColumn> : <RaikoGridOneColumn>
                        <RaikoAlert
                            type={raikoAlertTypes.warning}
                            title={"هیچ دسته بندی یافت نشد !"}
                            description={[
                                "* لطفا ابتدا از قسمت دسته بندی ها، دسته بندی های مورد نظر خود را اضافه نمایید!"
                            ]}
                        />
                    </RaikoGridOneColumn>
            }


        </>
    )
}
export default Category;
const defaultValue = [{
    "id": 2,
    "slug": "food",
    "metaData": {"title": "رستوران و فست فود"},
    "children": [{
        "id": 10,
        "slug": "fast food",
        "parent": {"id": 2, "slug": "food"},
        "metaData": {"title": "فست فود"},
        "children": null
    }, {
        "id": 9,
        "slug": "Restaurant",
        "parent": {"id": 2, "slug": "food"},
        "metaData": {"title": "رستوران"},
        "children": null
    }]
}, {
    "id": 3,
    "slug": "treatment",
    "metaData": {"title": "رفاهی و درمانی"},
    "children": [{
        "id": 15,
        "slug": "pharmacy",
        "parent": {"id": 3, "slug": "treatment"},
        "metaData": {"title": "داروخانه"},
        "children": null
    }, {
        "id": 14,
        "slug": "Car service",
        "parent": {"id": 3, "slug": "treatment"},
        "metaData": {"title": "خدمات خودرو"},
        "children": null
    }, {
        "id": 13,
        "slug": "Transportation",
        "parent": {"id": 3, "slug": "treatment"},
        "metaData": {"title": "حمل و نقل"},
        "children": null
    }, {
        "id": 12,
        "slug": "Services",
        "parent": {"id": 3, "slug": "treatment"},
        "metaData": {"title": "خدمات"},
        "children": null
    }, {
        "id": 11,
        "slug": "Store",
        "parent": {"id": 3, "slug": "treatment"},
        "metaData": {"title": "فروشگاه "},
        "children": null
    }, {
        "id": 4,
        "slug": "hospital",
        "parent": {"id": 3, "slug": "treatment"},
        "metaData": {"title": "بیمارستان"},
        "children": null
    }]
}, {
    "id": 16,
    "slug": "residence",
    "metaData": {"title": "اقامتگاه "},
    "children": [{
        "id": 19,
        "slug": "ecotourism house",
        "parent": {"id": 16, "slug": "residence"},
        "metaData": {"title": "خانه بوم گردی"},
        "children": null
    }, {
        "id": 18,
        "slug": "motel",
        "parent": {"id": 16, "slug": "residence"},
        "metaData": {"title": "مهمانپذیر"},
        "children": null
    }, {
        "id": 17,
        "slug": "Hotel",
        "parent": {"id": 16, "slug": "residence"},
        "metaData": {"title": "هتل"},
        "children": null
    }]
}, {
    "id": 1,
    "slug": "pilgrimage-and-tourism",
    "metaData": {"title": "زیارتی و سیاحتی"},
    "children": [{
        "id": 8,
        "slug": "mosque",
        "parent": {"id": 1, "slug": "pilgrimage-and-tourism"},
        "metaData": {"title": "مسجد"},
        "children": null
    }, {
        "id": 7,
        "slug": "Pantheon",
        "parent": {"id": 1, "slug": "pilgrimage-and-tourism"},
        "metaData": {"title": "زیارتگاه "},
        "children": null
    }, {
        "id": 6,
        "slug": "cultural",
        "parent": {"id": 1, "slug": "pilgrimage-and-tourism"},
        "metaData": {"title": "فرهنگی"},
        "children": null
    }, {
        "id": 5,
        "slug": "Tourism",
        "parent": {"id": 1, "slug": "pilgrimage-and-tourism"},
        "metaData": {"title": "گردشگری"},
        "children": null
    }]
}, {"id": 20, "slug": "processions", "metaData": {"title": "مواکب"}, "children": null}]